import { endPoints } from 'api/';
import { active } from 'constants/status';
import { employee } from 'constants/user';
import { GET_PEOPLES } from 'actions/types';

/**
 * @description Get a list of all peoples.
 * @param {{
 *   companyId : string,
 *   lowerDate : string,
 *   upperDate : string,
 * }} params
 * @returns Array of people objects
 */
function getPeoples({ companyId, lowerDate, upperDate }) {
  const hasDate = !!lowerDate && !!upperDate;
  const dateFilter = hasDate
    ? `,"createdat": "btwn::${lowerDate},${upperDate}"`
    : '';
  const query = `?where={"company_id": "${companyId}", "status": "${active}", "has_access": "false", "usertype": "${employee}" ${dateFilter}}`;
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_PEOPLES,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const people = await apiClient(endPoints.GET_USERS, {}, query);
        return people;
      },
    };

    dispatch(action);
  };
}

export default getPeoples;
